import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import * as d3 from 'd3';
declare var $: any;
@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html'
})
export class PieChartComponent implements OnInit {
    @Input() GraphData: any;
    @Input() chartContainer: any;
    @Input() categoryId: any;
    @Input() tobeExcluded: any;
    @Input() currentGroup: number;
    valuesPerPage:number = 5;
  constructor() { }
  ngOnInit(): void {
  }
  ngAfterViewInit() {
    this.RenderPIECharts(this.GraphData, this.chartContainer, this.categoryId, this.tobeExcluded); //, this.currentGroup
  }
  RenderPIECharts(pieChartContainer, categoryId, tobeExcluded = null, currentGroup = 1) {
    d3.select(pieChartContainer).html("");
    let that = this;
    var categoryData = this.GraphData.filter((d) => d.CategoryId == categoryId);
    var pieData = [];
    var sevValues = [];
    var tobeIncluded = [];
    var valuesPerPage = 5;
    var text = "";
    if (categoryData != null && categoryData.length > 0) {
        Object.keys(categoryData[0].SeverityData).forEach((key) => {
            //pieData.push({ 'name': key, 'value': categoryData[0].SeverityData[key] });
            sevValues.push(key);
        });
    }
    else
        return;
    tobeIncluded = sevValues.slice(0);
    if (tobeExcluded != null && tobeExcluded.length > 0) {
        //sevValues = sevValues.filter(val => !tobeExcluded.includes(val)); // to remove duplicates - unique values
        tobeIncluded = tobeIncluded.filter(function (val) {    // To get duplicates - common values
            return tobeExcluded.indexOf(val) != -1;
        });
    }
    else if (tobeExcluded == null)
        tobeExcluded = tobeIncluded.slice(0);
    else
        tobeIncluded.length = 0;
    tobeIncluded.forEach((key) => {
        pieData.push({ 'name': key, 'value': categoryData[0].SeverityData[key] });
    });
    //console.log('pie width : ' + pieChartContainer.clientWidth)
    var margin = { top: 0, right: 0, bottom: 0, left: 0 };
    var width = pieChartContainer.clientWidth;// - 50;
    var height = 95;
    var padding = 10;
    var opacity = .9;
    var otherOpacityOnHover = .8;
    var radius = Math.min(width - padding, height - padding) / 2;
    //var color = d3.scaleOrdinal(d3.schemeCategory10);

    var svg = d3.select(pieChartContainer)
        .append('svg')
        .attr('class', 'pie')
        .attr('id', 'svg_' + pieChartContainer.getAttribute('id'))
        .classed("resizableSVG", true)
        .attr('xmlns', "http://www.w3.org/2000/svg")
        .attr('viewBox', "0 0 " + width + " " + height + "")
        .attr('preserveAspectRatio', 'xMidYMid meet')
        //.attr('svg_' + heatMapData.chartContainerName)
        .attr('width', width)
        .attr('height', height)
        .style('overflow', 'visible')
        .append('g');

    var arc = d3.arc()
        .innerRadius(0)
        .outerRadius(radius - 5);

    var arc2 = d3.arc()
        .outerRadius(radius + 5)
        .innerRadius(0);

    var pie = d3.pie()
        .value((d) => parseInt(d.value))
        .sort(null);

    var g1 = svg.append('g')
        .attr('class', 'piearcs')
        //.attr('transform', 'translate(' + (width / 2) + ',' + (height / 2) + ')');
        .attr('transform', 'translate(' + (height / 2) + ',' + (height / 2) + ')');
    var g = svg.append('g')
        .attr('class', 'piearcs')
        //.attr('transform', 'translate(' + (width / 2) + ',' + (height / 2) + ')');
        .attr('transform', 'translate(' + (height / 2) + ',' + (height / 2) + ')');

    var path1 = g1.selectAll('path')
        .data(pie(pieData))
        .enter()
        .append("g")
        .append('path')
        .attr('d', arc2)
        .classed('HoverPath', true)
        .attr('id', (d, i) => 'HoverPath_' + i)
        .attr('fill', ((d, i) => that.getColor(d.data.name.toUpperCase())))
        .style('opacity', 0)

    var path = g.selectAll('path')
        .data(pie(pieData))
        .enter()
        .append("g")
        .append('path')
        .attr('d', arc)
        .attr('fill', ((d, i) => that.getColor(d.data.name.toUpperCase())))
        .style('opacity', opacity)
        .on("mouseover", function (d, i) {
            d3.select(pieChartContainer).select('svg').selectAll('.piearcs').selectAll('path')
                .style("opacity", otherOpacityOnHover)
                .attr('d', arc);
            d3.select(this)
                .attr("d", arc2)
                .style("opacity", 0.3);
                that.mouseHover(pieChartContainer, this, d.data.name, d.data.value, i);
        })
        .on("mousemove", function (d) {
            var transformResult = that.mouseMove(pieChartContainer, this, height, width);
            d3.select(pieChartContainer).select("svg").select('.tooltip')
                .style("opacity", 1)
                .attr('transform', `translate(${transformResult.x - 85}, ${transformResult.y - 35})`);
        })
        .on("mouseout", function (d, i) {
            that.mouseOut(pieChartContainer, this, opacity, i);
            d3.select(pieChartContainer).select('svg').selectAll('.piearcs').selectAll('path')
                .style("opacity", otherOpacityOnHover)
                .attr("d", arc)
        });

    var startHieght = 5 + (sevValues.length == 1 ? 36 : (sevValues.length == 2 ? 26 : (sevValues.length == 3 ? 18 : (sevValues.length == 4 ? 12 : 0))));
    //var startHieght = 5 + (valuesPerPage == 1 ? 36 : (valuesPerPage == 2 ? 26 : (valuesPerPage == 3 ? 18 : (valuesPerPage == 4 ? 12 : 0))));
    var legendsSVG = svg.append('g')
        .attr('transform', "translate(" + 110 + "," + startHieght + ")")
        .attr('width', 45)
        .attr('height', 90)
        .attr('class', 'LegendsG')
        .style('overflow', 'auto');
    legendsSVG.append('rect')
        .attr('fill', 'none')
        .attr('rx', "0")
        .attr('ry', "0")
        .attr('x', "0")
        .attr('y', "0")
        .attr('width', 45)
        .attr('height', 90);
    var legendGroups = legendsSVG.append('g');
    var legendGroup = legendGroups.append('g').selectAll('g')
        .data(sevValues)
        .enter()
        .append('g')
        .on('click', (d, i) => {
            //console.log('clicked' + i);
            if ($(legendGroup.nodes()[i]).find('rect').attr('fill') != '#cccccc') {
                tobeExcluded.splice(tobeExcluded.indexOf(d), 1);
                //$(legendGroup.nodes()[i]).find('rect').attr('fill','#cccccc');
            }
            else {
                tobeExcluded.splice(tobeIncluded.indexOf(d), 0, d);
            }
            var x = parseInt(legendGroup.nodes().filter(d => $(d).css('display') != 'none')[0].id);
            that.RenderPIECharts(pieChartContainer, categoryId, tobeExcluded, x);
        });
    legendGroup.append('text')
        .style("color", "#015b63")
        .style("font-size", "9px")
        //.style("font-weight", "bold")
        .style("cursor", "pointer")
        .style("fill", "#015b63")
        .attr("text-anchor", "start")
        .attr("x", "12")
        .attr("y", "12")
        .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
        .append('tspan')
        .text((d, i) => {
            if (d.length > 16) {
                d = d.substring(0, 13) + '...';
            }
            return d;
        })
        .on('mouseover', (d, i) => {
            $(legendGroup.selectAll('text').nodes()[i]).css('font-weight', 'bold');
        })
        .on('mouseout', (d, i) => {
            $(legendGroup.selectAll('text').nodes()[i]).css('font-weight', "normal");
        })
        .append('title')
        .text(d => d.length > 16 ? d : null);

    legendGroup.append('rect')
        .attr("x", "2")
        .attr("y", "4")
        .attr("width", "8")
        .attr("height", "8")
        .attr('fill', (d, i) => {
            return that.getColor(d);
        })
        .attr("rx", "6")
        .attr("ry", "6");
    var symbol = d3.symbol();
    var legendScroll = legendGroups.append('g')
        .attr('transform', "translate(" + 100 + "," + 5 + ")")
        .attr('class', 'legendscroll');
    var LegentScrollText = legendScroll.append('text')
    legendScroll.append("path")
        .attr("d", symbol.type(d3.symbolTriangle).size(30))
        .attr('class', 'uppertriangle')
        .attr('fill', '#cccccc')
        .style('cursor', 'default')
        .on('click', () => {
            var i = parseInt(legendGroup.nodes().filter(d => $(d).css('display') != 'none')[0].id);
            var totalGrps = parseInt(legendScroll.attr('total'));
            if (i > 1) {
                legendGroup.nodes().filter(d => d.getAttribute('id') == i)
                    .forEach((d, i) => d.setAttribute('display', 'none'));
                var lblGrps = legendGroup.nodes().filter(d => d.getAttribute('id') == (i - 1));
                that.scrollLegendsPie(lblGrps, 90, legendScroll, false, LegentScrollText, valuesPerPage);
                legendScroll.select('text')
                    .text((i - 1) + "/" + totalGrps);
            }
            if (i != 1 && (i - 1) < totalGrps) {
                legendScroll.select('.lowertriangle').node().setAttribute('fill', '#003399');
                $(legendScroll.select('.lowertriangle').node()).css('cursor', 'pointer');
            }
            else {
                legendScroll.select('.lowertriangle').node().setAttribute('fill', '#cccccc');
                $(legendScroll.select('.lowertriangle').node()).css('cursor', 'default');
            }
            if ((i - 1) <= 1) {
                //legendScroll.select('.lowertriangle').node().setAttribute('fill', '#003399');
                //$(legendScroll.select('.lowertriangle').node()).css('cursor', 'pointer');
                legendScroll.select('.uppertriangle').node().setAttribute('fill', '#cccccc');
                $(legendScroll.select('.uppertriangle').node()).css('cursor', 'default');
            }
            else {
                legendScroll.select('.uppertriangle').node().setAttribute('fill', '#003399');
                $(legendScroll.select('.uppertriangle').node()).css('cursor', 'pointer');
            }
        });
    //var dummyLegendGroup = legendGroup;
    legendScroll.append("path")
        .attr("d", symbol.type(d3.symbolTriangle))
        .attr('transform', "translate(0" + "," + 80 + ") rotate(180)")
        .attr('class', 'lowertriangle')
        .style('cursor', 'pointer')
        .attr('fill', '#003399')
        .on('click', () => {
            that.clickScrollDownPie(legendGroup.nodes(), 90, legendScroll, false, LegentScrollText, 1);
        });
    var grpNodes = legendGroup.nodes();
    that.scrollLegendsPie(grpNodes, 90, legendScroll, true, LegentScrollText, valuesPerPage);
    if (currentGroup != 1) {
        that.clickScrollDownPie(grpNodes, 90, legendScroll, false, LegentScrollText, (currentGroup - 1));
    }
    else {
        grpNodes.filter(d => d.getAttribute('id') != 1)
            .forEach((d, i) => d.setAttribute('display', 'none'));
    }
    legendScroll.select(".lowertriangle")
        .attr('transform', "translate(0" + "," + ($(grpNodes.filter(x => $(x).css('display') == 'block')[0]).parent()[0].getBBox().height - 5) + ") rotate(180)")
    //}
    sevValues.forEach((d, i) => {
        if (!tobeIncluded.includes(d))
            $(legendGroup.nodes()[i]).find('rect').attr('fill', '#cccccc');
    });
    if (grpNodes.length <= valuesPerPage) {
        legendScroll.select(".lowertriangle").attr('display', 'none');
        legendScroll.select(".uppertriangle").attr('display', 'none');
    }
}
clickScrollDownPie(legendGroupNodes, width, legendScroll, isUpdateId, LegentScrollText, increment) {
    var i = parseInt(legendGroupNodes.filter(d => $(d).css('display') != 'none')[0].id);
    var totalGrps = parseInt(legendScroll.attr('total'));
    if (totalGrps > i) {
        legendGroupNodes.filter(d => d.getAttribute('id') != (i + increment))
            .forEach((d, i) => d.setAttribute('display', 'none'));
        legendGroupNodes.filter(d => d.getAttribute('id') == (i + increment))
            .forEach((d, i) => d.setAttribute('display', 'block'));
        var lblGrps = legendGroupNodes.filter(d => d.getAttribute('id') == (i + increment));
        this.scrollLegendsPie(lblGrps, width, legendScroll, isUpdateId, LegentScrollText, 5);
        legendScroll.select('text')
            .text((i + increment) + "/" + totalGrps);
        legendScroll.select('.uppertriangle').node().setAttribute('fill', '#003399');
        $(legendScroll.select('.uppertriangle').node()).css('cursor', 'pointer');
    }
    if ((i + increment) >= totalGrps) {
        //legendScroll.select('.uppertriangle').node().setAttribute('fill', '#003399');
        //$(legendScroll.select('.uppertriangle').node()).css('cursor', 'pointer');
        legendScroll.select('.lowertriangle').node().setAttribute('fill', '#cccccc');
        $(legendScroll.select('.lowertriangle').node()).css('cursor', 'default');
    }
    else {
        legendScroll.select('.lowertriangle').node().setAttribute('fill', '#003399');
        $(legendScroll.select('.lowertriangle').node()).css('cursor', 'pointer');
    }
}
scrollLegendsPie(legendGroupNodes, width, legendScroll, isUpdateId, LegentScrollText, valuesPerPage) {
    var labels = legendGroupNodes//.nodes()//.selectAll('text');
    var textWidth = 0;
    var textHeight = 0;
    var space = 20;
    var totalLines = 1;
    var groupNumber = 1;
    labels.forEach(function (d, i) {
        if ((textWidth + d.getBBox().width) <= width) {
            labels[i].setAttribute('transform', 'translate(' + textWidth + ',' + textHeight + ')');
            labels[i].setAttribute('display', 'block')
            if (isUpdateId)
                labels[i].setAttribute('id', groupNumber);
        }
        else {
            totalLines += 1;
            textWidth = 0;
            textHeight += 18;
            labels[i].setAttribute('transform', 'translate(' + textWidth + ',' + textHeight + ')');
            labels[i].setAttribute('display', 'block')
            if ((totalLines - 1) % valuesPerPage == 0) // totalLines > valuesPerPage && 
                groupNumber += 1;
            if (isUpdateId)
                labels[i].setAttribute('id', groupNumber);
        }
        textWidth += d.getBBox().width;
        textWidth += space;
    });
    LegentScrollText.style('display', 'none');
    //.text("1/" + Math.ceil(totalLines / valuesPerPage))
    //.attr('fill', 'rgb(1, 91, 99)')
    //.attr('transform', "translate(-10" + "," + 20 + ")");
    //legendScroll.select(".lowertriangle")
    //    .attr('transform', "translate(0" + "," + ($(labels.filter(x => $(x).css('display') == 'block')[0]).parent()[0].getBBox().height - 5) + ") rotate(180)")
    if (isUpdateId)
        legendScroll.attr('total', Math.ceil(totalLines / valuesPerPage));
    if (Math.ceil(totalLines / valuesPerPage) == 1) {
        legendScroll.select('.lowertriangle').node().setAttribute('fill', '#cccccc');
        $(legendScroll.select('.lowertriangle').node()).css('cursor', 'default');
    }
}
getColor(value) {
    //console.log(d3.scaleOrdinal(d3.schemeCategory10)["test"])
    if (value.indexOf("1") >= 0 || value.indexOf("critical".toUpperCase()) >= 0)
        return '#c02000';
    else if (value.indexOf("2") >= 0 || value.indexOf("high".toUpperCase()) >= 0)
        return '#4e665e';//'#ff9900';
    else if (value.indexOf("3") >= 0 || value.indexOf("medium".toUpperCase()) >= 0)
        return '#bf7300';//'#7cb2a5';
    else if (value.indexOf("4") >= 0 || value.indexOf("low".toUpperCase()) >= 0)
        return '#1c8186';//'#004A66';
    else if (value.indexOf("5") >= 0 || value.indexOf("very".toUpperCase()) >= 0)
        return '#a9ff96';
    else if (value.indexOf("blank".toUpperCase()) >= 0)
        return '#7cb5ec';
    else
        return d3.scaleOrdinal(d3.schemeCategory10)[value];
}
mouseHover(container, pathElement, name, value, i) {
    d3.select(pathElement).style('cursor', 'pointer');
    d3.select(container).select("svg").select('#trend_circle_' + i).style("display", 'block');
    var tooltip = d3.select(container).select("svg")
        .append("g")
        .style("cursor", "pointer")
        .attr("class", "tooltip")
        .style("opacity", 1)
    tooltip.append("rect")
        .attr("width", 90)
        .attr('height', 40)
        .style('fill', '#FFFFFF')
        .style('pointer-events', 'none')
        .style('stroke', this.ConvertRGB2Hex(d3.select(pathElement).style('fill')) == '#ffffff' ? "#296986" : d3.select(pathElement).style('fill'))
        .style('stroke-width', 2)
        .style('fill-opacity', 0.8);
    var textSvg = tooltip.append("text")
        .attr('x', 7)
        .attr('y', 15)
        .style('pointer-events', 'none')
        .style('fill', '#333333')
        .style('font-size', '12px')
        .style('color', '#333333');
    textSvg.append("tspan")
        .style('font-size', '10px')
        .style('pointer-events', 'none')
        .style('font-weight', 'bold')
        .text(name)
    textSvg.append("tspan")
        .attr('x', 7)
        .attr('dy', 15)
        .style('pointer-events', 'none')
        .style('fill', this.ConvertRGB2Hex(d3.select(pathElement).style('fill')) == '#ffffff' ? "#296986" : d3.select(pathElement).style('fill'))
        .html('&#x25cf') //&#9679; //&bull;
    textSvg.append("tspan")
        .attr('dx', 0)
        .style('pointer-events', 'none')
        .style('font-size', '11px')
        .text('Tickets: ')
        .style('font-weight', 'bold')
    textSvg.append("tspan")
        .attr('dx', 0)
        .style('pointer-events', 'none')
        .style('font-weight', 'bold')
        .text(d3.format(',')(parseInt(value)));
}
mouseMove(container, pathElement, height, width) {
    d3.select(pathElement).style('cursor', 'pointer');
    var mousePosition = d3.mouse(pathElement);
    var x = mousePosition[0] + width / 2;
    //console.log("0 : " + mousePosition[0] + "x : " + x);
    var y = mousePosition[1] + height / 2;
    //console.log("1 : " + mousePosition[1] + "y : " + y);
    var text = d3.select(container).select("svg").select('.tooltip text');
    var bbox = text.node().getBBox();
    //console.log("bbox w : " + bbox.width);
    d3.select(container).select("svg").select('.tooltip rect')
        .attr("width", bbox.width + 15)
    //console.log("bbox h : " + bbox.height);
    if (x - bbox.width / 2 < 0) {
        x = bbox.width / 2;
    }
    else if (width - x - bbox.width / 2 < 0) {
        x = width - bbox.width / 2;
    }
    if (y - bbox.height / 2 < 0) {
        y = bbox.height * 2;
    }
    else if (height - y - bbox.height / 2 < 0) {
        y = height - bbox.height / 2;
    }
    return {
        'x': x, 'y': y
    };
    // when mouse moves         
    //console.log("mouse X: " + d3.event.layerX);
    //console.log("mouse Y: " + d3.event.layerY);
    //console.log(d3.select(pieChartContainer.nativeElement).select("svg").select('.tooltip').html());
    //d3.select(pieChartContainer.nativeElement).select("svg").select('.tooltip')//.style('top', (d3.event.layerY + 10) + 'px') // always 10px below the cursor
    //    .attr('transform', `translate(${d3.event.layerX-30}, ${d3.event.layerY-30})`)
    //.style('left', (d3.event.layerX + 10) + 'px'); // always 10px to the right of the mouse    
}
mouseOut(container, pathElement, opacity, i) {
    d3.select(container).select("svg").select('.tooltip').style('display', 'none');
    d3.select(container).select("svg").select('#trend_circle_' + i).style("display", 'none');
    d3.select(container).select("svg")
        .select(".tooltip").remove();
    d3.select(pathElement).selectAll('path')
        .style("opacity", opacity);
}
ConvertRGB2Hex(rgb) {
    rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return (rgb && rgb.length === 4) ? "#" +
        ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
        ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
        ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
}
}
